import { CommonModule } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { FnGoogleLocationDirective } from './fn-google-location.directive';
import { FnGoogleLocationService } from './fn-google-location.service';
 

export * from './fn-google-location.directive';
export * from './fn-google-location.service';
export * from './fn-google-location.model';

@NgModule({ declarations: [FnGoogleLocationDirective],
    exports: [FnGoogleLocationDirective], imports: [CommonModule], providers: [FnGoogleLocationService, provideHttpClient(withInterceptorsFromDi())] })
export class FnGoogleLocationModule {
  static forRoot(): ModuleWithProviders<FnGoogleLocationModule> {
    return {
      ngModule: FnGoogleLocationModule,
      providers: [FnGoogleLocationService],
    };
  }
}
